__turbopack_context__.v({
  "cls1": "IlluProject-module__XCfL0W__cls1",
  "cls2": "IlluProject-module__XCfL0W__cls2",
  "cls3": "IlluProject-module__XCfL0W__cls3",
  "cls4": "IlluProject-module__XCfL0W__cls4",
});
